export const URLAPISUBIDA = 'https://corporacioncessa.edu.co/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://corporacioncessa.edu.co/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://corporacioncessa.edu.co/notis/'

export const URLAPISUBIDAPDF = 'https://corporacioncessa.edu.co/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://corporacioncessa.edu.co/notis/'